module.exports = __webpack_public_path__ + "img/39_73.cf216297.png";